import { useContext, useEffect, useState } from 'react';
import QuickReplySkeleton from '../../Email/pages/QuickReplySkeleton';
import ApiList from '../assets/ApiList';
import LinkFile from '../LinkFile';
import { updateFileTypeFlag, updateIsShowQuickReplyFlag, updateTemplateData } from '../reducers/Action';
import { VoiceSendContext } from '../reducers/GlobalReduers';
import { PRIVACY_LEVEL } from '../../../../helpers/CoreConstant';
import GlobalPrivacyTab from '../../globalPrivacyTab';
import EmptyStateMessageWithPicture from '../../../GlobalContactDetailsForDeal/LeftSide/common/EmptyStateMessageWithPicture';

const QuickRepliesForVoiceTemplates = (props) => {
    const {dispatch} = useContext(VoiceSendContext)
    const [isLoading, setIsLoading] = useState(true)
    const [templates, setTemplates] = useState([])

    /* for fetching data onscroll */
    const [perPage, setPerPage] = useState(20)
    const [currentPage, setCurrentPage] = useState(0)

    const [activeTab, setActiveTab] = useState(PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL);

    useEffect(() => {
        if(props.scrolling){
            ApiList.getVoiceTemplates({
                search_key: "",
                type: 3,
                'perPage': perPage,
                'page': currentPage + 1,
                privacy_level: activeTab
            }).then(res => {
                let response = res.data
                if(response.status === 'success'){
                    setCurrentPage(currentPage + 1);
                    if(response.html.length >= perPage){
                        if(props.updateScrollOption !== undefined){
                            props.updateScrollOption("needToLoad", true)
                        }
                    }
                    else{
                        if(props.updateScrollOption !== undefined){
                            props.updateScrollOption("needToLoad", false)
                        }
                    }
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("fetchingMore", false)
                    }
                    setTemplates([...templates, ...response.html])
                }
            })
        }
    }, [props.scrolling]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // get all email template
        ApiList.getVoiceTemplates({
            search_key: "",
            type: 3,
            'perPage': perPage,
            'page': 0,
            privacy_level: activeTab
        }).then(res => {
            let response = res.data
            if(response.status === 'success'){
                setCurrentPage(0);
                setTemplates(response.html)

                if(response.html.length >= perPage){
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("needToLoad", true)
                    }
                }
                else{
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("needToLoad", false)
                    }
                }
                if(props.updateScrollOption !== undefined){
                    props.updateScrollOption("fetchingMore", false)
                }
            }
            setIsLoading(false)
        })
        return () => setIsLoading(true)
    }, [activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleIsShowTemplate = () => {
        dispatch(updateIsShowQuickReplyFlag(false))
    }

    const hanldeTemplateChange = (item) => {
        dispatch(updateFileTypeFlag('TEMPLATE'))
        if(item.template_files !== undefined && item.template_files != null){
            dispatch(updateTemplateData({
                data: item?.template_files?.file,
                id: item.template_file_id,
                flag: 'template_file'
            }))
        }
        else{
            dispatch(updateTemplateData({
                data: item?.video_file_url,
                id: item.id,
                flag : 'template'
            }))
        }
        handleIsShowTemplate()
    }

    const renderList = () => {
        let list = []
        templates.forEach((item, index) => {
            list.push(
                <LinkFile.QucikReplyCard
                    data={item}
                    key={index}
                    onSelect={hanldeTemplateChange}
                />
            )
            // list.push(
            //     <div className="g-template-each-voice" key={index}>
            //         <span className="g-template-each-title-voice">{item.title}</span>
            //         <div className="g-template-file-view">
            //             <audio className="g-template-file" controls src={item.template_files?.file} />
            //             <span className="g-template-each-select" onClick={() => hanldeTemplateChange(item)}><CheckIcon /> Use</span>
            //         </div>
            //     </div>
            // )
        });
        return list;
    }

    const handleActiveTab = (_event, newValue) => {
        setActiveTab(newValue);
    };

    return(
        <div className="g-email-template-content">
            <div className="g-template-header">
                <span className="g-template-title">Quick Reply List</span>
                <div className="g-template-back" onClick={handleIsShowTemplate}> {'<<'} Back</div>
            </div>

            <GlobalPrivacyTab activeTab={activeTab} handleTabChange={handleActiveTab} />
            
            <div>
                {isLoading ? 
                    <QuickReplySkeleton/>                :
                    renderList()
                }
            </div>

            {
                !isLoading && templates.length === 0 && (<EmptyStateMessageWithPicture />)
            }
        </div>
    )
}
export default QuickRepliesForVoiceTemplates;


